import { FileKind } from "../../modes/define/FileKind";
import { GeneralKind } from "../../modes/define/GeneralKind";
import { MessageEventKind } from "../../modes/define/MessageEventKind";
import NormalGameManager from "../../modes/normalMode/manager/NormalGameManager";
import { OpenOreSpecialCollect } from "../../modes/normalMode/prefab/openOreGame/openOreConst";
import O1HD from "../gameEngine";
import data_control from "./data_control";
import ParseCSV from "./ParseCSV";

export default class utilsModel {

     /**
      * 读取csv文件
      * @param bundle 
      * @param filename 
      * @param func 
      * @returns 
      */
    static async readCsvData(bundle: cc.AssetManager.Bundle, filename: string, func?: (array: any)=> void){
        return new Promise<any>(resolve => {
            bundle = bundle || cc.resources;
            bundle.load(filename, function (err, string) {
                if (err) {
                    console.error(`csv读取错误 filename = ${filename}  `, err.message || err);
                    resolve(null);
                    return;
                }
    
                // cc.log("read finish ", string.toString());
                
                let array = ParseCSV.csvToArray(string.toString())
    
                cc.assetManager.releaseAsset(string);
                
                // cc.log('arr ', array);
                if (func) {
                    func(array)
                }
                resolve(array);
            });
        });
    }

    /**
     * 解析csv数据
     * @param array 
     * @param bFirstMap 
     * @returns 
     */
    static parseCsvData(array: any, bFirstMap: boolean = false) {
        let data = {};
        data['title'] = {}
            
        for (let i in array[1]){
            data['title'][array[1][i]] = i;
        }

        let idIndex = data['title'].id ?? 0;
        for(let i = 2; i < array.length; i++){
            if (bFirstMap) {
                if (!data[array[i][idIndex]]) {
                    data[array[i][idIndex]] = [];
                }
                data[array[i][idIndex]].push(array[i]);
            } else {
                data[array[i][idIndex]] = array[i];
            }
            
        }
        return data;
    }
    
    static transCsvDataLine(csvData: any, id: string): any {
        let _title = csvData.title;
        let info = csvData[id];
        if (!info) {
            return null;
        }
        let result = {};
        for (let n in _title) {
            result[n] = info[_title[n]];
        }
        return result;
    }
    
    /**
     * 是否有效数值
     * @param value 
     */
    static isValidNumberValue(value: number | string) {
        if (value == undefined || value == null 
            || value == -1
        ) {
            return false;
        }
        if (typeof value == 'number' && isNaN(value)) {
            return false;
        }  
        if (typeof value == 'string' && value == '') {
            return false;
        }
        return true;
    }

    /**
     * 获取json数据长度
     * @param jsonData 
     */
    static getJsonDataLength(jsonData: any) {
        if (!jsonData) {
            return 0;
        }

        let count = 0;
        for (let i in jsonData) {
            count++;
        }
        return count;
    }

    /** 是否在观看广告中 */
    static bLookAding = false;
    /**
     * 加载并显示视频广告
     * @param successCallback 成功回调
     * @param errorCallback 失败回调
     * @param completeCallback 完成回调
     * @param reportAnalyticsExplain 成功上报描述
     */
    static loadAndShowVideoAdTrans(
        successCallback: () => void,
        errorCallback: (error: any) => void,
        completeCallback?: () => void,
        reportAnalyticsExplain?: string
    ): void 
    { 
        if (this.bLookAding) {
            console.log('重复点击广告');
            return;
        }
        this.bLookAding = true;

        let goodsId = GeneralKind.PropId.AD_CARD;
        let goodsData = NormalGameManager._instance.getOneGood(goodsId);
        if (goodsData && goodsData.num > 0) {
            goodsData.num--;
            NormalGameManager._instance.writeGameData();
            O1HD.emit(MessageEventKind.EventName.REFRESH_AD_CARD_COUNT);
            console.log('使用免广告卡');
            this.bLookAding = false;
            if (successCallback) {
                successCallback();
            }
            return;
        }

        // if (!O1HD.getServices().miniGameSrv.getAppApiInstance().isProduction()) {
        //     this.bLookAding = false;
        //     if (successCallback) {
        //         successCallback();
        //     }
        //     return;
        // }
                
        O1HD.getServices().miniGameSrv.getAppApiInstance().loadAndShowVideoAd(
            ()=> {
                this.bLookAding = false;
                if (successCallback) {
                    successCallback();
                }
            }
            , (error)=> {
                this.bLookAding = false;
                if (errorCallback) {
                    errorCallback(error);
                }
            }
            , ()=> {
                this.bLookAding = false;
                if (completeCallback) {
                    completeCallback();
                }
            }
            , reportAnalyticsExplain
        );
    }

    static onPushGoods(id: number, count: number) {
        let t = OpenOreSpecialCollect;
        let nidx = t.indexOf(id);
        let gameData = NormalGameManager._instance.getGameData();
        if (nidx != -1) {
            if (!gameData.nvWaStore[nidx]) {
                gameData.nvWaStore[nidx] = true;
                
                NormalGameManager._instance.writeGameData();
                if (count > 1) {
                    NormalGameManager._instance.onPushGoods(id, count-1);    
                }
            } else {
                NormalGameManager._instance.onPushGoods(id, count);
            }
        } else {
            NormalGameManager._instance.onPushGoods(id, count);
        }
    }

    /**
     * csv表格数据换行分隔
     * @param strParse 
     * @returns 
     */
    static splitLineFeed(strParse: string) {
        strParse = strParse.trim();
        let splitType = FileKind.ResParseType.BIG_ITEM;
        if (!strParse.includes(splitType)) {
            splitType = FileKind.ResParseType.BIG_ITEM2;
        }
        return strParse.split(splitType);
    }

    /**
     * 数值解析
     * @param strNumber 
     * @returns 
     */
    static csvNumberParse(strNumber: string) {
        strNumber = strNumber.trim().replace(/,/g, '');
        let num = Number(strNumber);
        return isNaN(num) ? 0 : num;
    }

    /**
     * 根据权重获得索引列表
     * @param weightList 
     * @param count 
     * @returns 
     */
    static getWeightsIdxList(weightList: string[], count: number) {
        let totalWeight = 0;
        let weightNumList: number[][] = [];
        for (let i = 0; i < weightList.length; i++) {
            let num = Number(weightList[i]);
            totalWeight += num;
            weightNumList.push([totalWeight, i]);
        }

        let retList: number[] = [];
        for (let c = 0; c < count; c++) {
            let randomW = data_control.randomNumInt(0, totalWeight);
            for (let i = 0; i < weightNumList.length; i++) {
                if (randomW <= weightNumList[i][0]) {
                    let cardId = weightNumList[i][1];
                    retList.push(cardId);
                    break;
                }
            }
        }
        return retList;
    }
}

